import { Runtime } from '@/core/enums/runtime.enum'

const RUNTIME_BY_LOWER_CASE = Object.fromEntries(
  Object.values(Runtime).map((runtime) => [runtime.toLowerCase(), runtime])
) as Record<string, Runtime>

export function normalizeRuntimeName(value: string | Runtime | undefined): Runtime {
  if (!value) {
    throw new Error('Runtime name is required')
  }

  if (Object.values(Runtime).includes(value as Runtime)) {
    return value as Runtime
  }

  const normalized = RUNTIME_BY_LOWER_CASE[String(value).trim().toLowerCase()]
  if (normalized) {
    return normalized
  }

  throw new Error(`Unsupported runtime: ${value}`)
}

export function tryNormalizeRuntimeName(value: string | Runtime | undefined): Runtime | undefined {
  try {
    return normalizeRuntimeName(value)
  } catch {
    return undefined
  }
}
